import React, {useState, useEffect} from 'react';
import { CollectingCandidatesRecruitmentPage } from './CollectingCandidatesRecruitmentPage';
import { InternsVSSRecruitmentPage } from './InternsVSSRecruitmentPage';
import { RegularRecruitmentPage } from './RegularRecruitmentPage';
import { useParams } from "react-router";
import { getByIdResource } from '../../service/http-service';


export const ActiveRecruitmentGenericPage = () => {
    const { id } = useParams();

    console.log({id});
    const [entity, setEntity] = useState({});
    var [form, setForm] = useState();

    useEffect(() => {

        getByIdResource("portal_recruitment/get_dto", id).then((data) =>{
                console.log('data vo getByIdResource vo Edit', data.data);
                console.log('data.data.recruitmentType vo getByIdResource vo Edit', data.data.recruitment.recruitmentType);
                setEntity(data.data);
                if(data.data.recruitment.recruitmentType === "REGULAR"){
                    setForm(<RegularRecruitmentPage  recruitment={data.data.recruitment} detailsList={data.data.detailsList} />);

                }
                if(data.data.recruitment.recruitmentType === "EXTERNAL_WITHOUT_POSITION"){
                    setForm(
                        <CollectingCandidatesRecruitmentPage recruitment={data.data.recruitment} detailsList={data.data.detailsList}/>

                    );
                }
                if(data.data.recruitment.recruitmentType === "INTERNSHIP"){
                    setForm(
                        <InternsVSSRecruitmentPage recruitment={data.data.recruitment} detailsList={data.data.detailsList}/>
                    );
                }
                if(data.data.recruitment.recruitmentType === "INTERNSHIP_SSS"){
                    setForm (
                        <InternsVSSRecruitmentPage recruitment={data.data.recruitment} detailsList={data.data.detailsList}/>

                    );
                }

            }

        );

    }, []);



    return(<div>{form}</div>);

};